import SellersLandingPage from "components/SellersLandingPage/SellersLandingPage";
import getTranslations from "../lib/getTranslations";

const SellersPage = () => {
  return <SellersLandingPage />;
};

SellersPage.getLayout = page => page;

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await getTranslations(locale, ["sellers-landing"])),
    },
  };
};

export default SellersPage;
